const Vue = require('vue')
const Validator = require('sci/helpers/validator')
const R = require('ramda')
const $ = require('jquery')

Vue.component('validate', {
    props: {
        value: {
            default: null
        },
        rule: String,
        field: String,
        name: String,
        data: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            instance: null,
            errors: []
        }
    },
    ready () {
        this.instance = new Validator({
            'rules': {
                [this.field]: this.rule
            },
            'messages': [],
            'attributes': {
                [this.field]: this.name
            }
        })

        R.forEach((el) => {
            el.addEventListener('blur', () => {
                this.validate()
            })
        }, this.$els.parent.querySelectorAll('input'))
    },
    methods: {
        validate () {
            this.instance
                .validate({
                    [this.field]: this.value,
                    ...this.data
                })
                .then(() => {
                    this.errors = []
                })
                .catch((ex) => {
                    this.errors = R.pipe(
                        R.values,
                        R.flatten
                    )(ex.data)
                })
        }
    },
    watch: {
        value () {
            this.validate()
        },
        errors (newVal) {
            this.$dispatch('validator:wipe-for', this.field)

            if (newVal.length) {
                newVal.slice(0, 1).forEach((message) => {
                    this.$dispatch('validator:add-invalid', {
                        field: this.field,
                        message: message
                    })
                })

                $(this.$els.parent).find('.form-group').addClass('has-validation-errors')
            } else {
                $(this.$els.parent).find('.form-group').removeClass('has-validation-errors')
            }
        }
    },
    computed: {
        error () {
            return R.head(this.errors)
        }
    },
    template: `
        <div v-el:parent class="pseudo-form-group" v-bind:class="{'has-errors': errors.length > 0}">
            <slot></slot>
            <div class="error-bag" v-if="error">
                <span class="help-block">
                    {{ error }}
                </span>
            </div>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/validate.js